/**
 * "Frequently used" on the dashboard: the last providers the user opened,
 * newest first, like the app's HISTORY_LIST (5 entries, stored on device).
 */
export type RecentProvider = {
  id: string;
  businessName: string;
  profileImage?: string | null;
  availability?: string | null;
};

export const RECENT_PROVIDERS_KEY = "casa-recent-providers";
export const MAX_RECENT_PROVIDERS = 5;

export function addRecentProvider(list: RecentProvider[], provider: RecentProvider): RecentProvider[] {
  return [provider, ...list.filter((item) => item.id !== provider.id)].slice(0, MAX_RECENT_PROVIDERS);
}

export function loadRecentProviders(): RecentProvider[] {
  try {
    const parsed = JSON.parse(localStorage.getItem(RECENT_PROVIDERS_KEY) ?? "[]");
    return Array.isArray(parsed) ? parsed.filter((item) => typeof item?.id === "string") : [];
  } catch {
    return [];
  }
}

export function rememberProvider(provider: RecentProvider) {
  try {
    localStorage.setItem(RECENT_PROVIDERS_KEY, JSON.stringify(addRecentProvider(loadRecentProviders(), provider)));
  } catch {
    // Storage full or blocked: the list is a convenience only.
  }
}

export function clearRecentProviders() {
  try {
    localStorage.removeItem(RECENT_PROVIDERS_KEY);
  } catch {
    // ignore
  }
}
